export const collapsibleSections = () => {

  // The wrapper of the collapsible section, including both content and the toggle button which can change style according to the data-state attribute.
  const collapsibleSection = '.js-collapsible-section';
  // The content section on which the max-height is applied. Has a transition animation in css.
  const collapsibleSectionContent = '.js-collapsible-section-content';
  // The inner section is needed to determine the max-height for its parent content div.
  const collapsibleSectionInner = '.js-collapsible-section-content';
  // The button which toggles the collapsible section.
  const collapsibleSectionToggle = '.js-collapsible-section-toggle';

  const init = () => {
    bind();
  };

  const bind = () => {

    function setHeight(section) {

      var content = section.children('.js-collapsible-section-content');
      var contentHeight = content.children('.js-collapsible-section-inner').outerHeight();
      var initialHeight = content.find('.js-collapsible-section-initial').outerHeight();
      console.log(initialHeight);

      if(section.attr('data-collapsed') == 'false') {
        content.css({'max-height':contentHeight});
      } else {
        content.css({'max-height':initialHeight});
        console.log(initialHeight);
      }

    }

    $(collapsibleSection).each(function() {
      setHeight($(this));
    });

    $(collapsibleSectionToggle).on('click', function(e) {
      e.preventDefault();
      var section = $(this).closest(collapsibleSection);
      section.attr('data-collapsed', section.attr('data-collapsed') =='true' ? 'false' : 'true');
      setHeight(section);
    });

  };

  init();

};
